import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
  })
);

export const VerticalLinearStepper = ({
  active,
  steps,
}: {
  active: number;
  steps: any;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Stepper
        activeStep={active}
        orientation="vertical"
        style={{
          padding: '24px 0',
        }}
      >
        {steps.map((step, index) => (
          <Step key={step.title} completed={index < active}>
            <StepLabel>
              <span
                style={{
                  fontSize: 18,
                  fontWeight: index == active ? 'bold' : 'normal',
                }}
              >
                {step.title}
              </span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
